import axios from 'axios'

const companyStore = {
  state: {
    company: null,
    coworkers: null,
  },
  getters: {
    company: (state: any) => state.company,
    coworkers: (state: any) => state.coworkers,
  },
  mutations: {
    setCompany (state: any, payload: any) {
      state.company = payload
    },
    setCoworkers (state: any, payload: any) {
      state.coworkers = payload
    },
    resetCompany (state: any) {
      state.company = null
      state.coworkers = null
    },
  },
  actions: {
    async fetchCompany ({ commit }: any, id: string | null = null) {
      try {
        if (id) {
          const result = await axios.get(`/api/company/${id}`)
          commit('setCompany', result.data)
        } else {
          const result = await axios.get('/api/company')
          if (result.data) {
            commit('setCompany', result.data)
          } else {
            commit('setCompany', null)
          }
        }
      } catch (err) {
        console.error('Error fetching company: ', err)
        commit('setCompany', null)
      }
    },
  },
}

export default companyStore
